import { useState } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import ShopByShapeForFilter from './FilerMenuShopByShape'

export default function FilterDrawer({ isOpen, setIsOpen }: any) {
  const router = useRouter()

  const [selectedStyle, setSelectedStyle] = useState('')
  const [selectedShape, setSelectedShape] = useState('')
  const [selectedMainStyle, setSelectedMainStyle] = useState('')
  const [priceRangeType, setPriceRangeType] = useState('under')
  const [minPrice, setMinPrice] = useState(0)
  const [maxPrice, setMaxPrice] = useState(1000000)

  const ringsCategory = [
    {
      name: 'Solitaire',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI1005RD/w1.png',
      param: 'subcategory=Solitaire&main_category=Rings',
    },
    {
      name: 'Halo',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      param: 'subcategory=Halo',
    },
    {
      name: 'Three Stone',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0625/w1.png',
      param: 'subcategory=Three%20Stone',
    },
    {
      name: 'Secret Halo',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0081/w1.png',
      param: 'subcategory=Hidden%20Halo',
    },
    {
      name: 'Bezel',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0508/w1.png',
      param: 'subcategory=Bezel',
    },
    {
      name: 'Nature Inspired',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
      param: 'subcategory=Nature%20Inspired',
    },
    {
      name: 'Designer',
      image:
        'https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/MEGA/VERI0695/w1.png',
      param: 'subcategory=Designer&main_category=Rings',
    },
  ]

  const handleReset = () => {
    setSelectedStyle('')
    setSelectedShape('')
    setSelectedMainStyle('')
    setPriceRangeType('under')
    setMinPrice(0)
    setMaxPrice(1000000)
  }

  const handleSubmit = () => {
    const queryParams = []

    if (selectedMainStyle) queryParams.push(selectedMainStyle)
    if (selectedShape) queryParams.push(selectedShape)
    if (selectedStyle) queryParams.push(selectedStyle)
    if (priceRangeType) {
      if (priceRangeType === 'between') {
        queryParams.push(
          `&priceRangeType=${priceRangeType}&priceRange=${minPrice}-${maxPrice}`
        )
      } else if (priceRangeType === 'under' && minPrice > 0) {
        queryParams.push(
          `&priceRangeType=${priceRangeType}&priceRange=${minPrice}`
        )
      } else if (priceRangeType === 'above' && maxPrice < 1000000) {
        queryParams.push(
          `&priceRangeType=${priceRangeType}&priceRange=${maxPrice}`
        )
      }
    }

    router.push(`/product-listing?${queryParams.join('&')}`)
    setIsOpen(false)
  }

  const hasFilters =
    selectedStyle ||
    selectedShape ||
    selectedMainStyle ||
    minPrice > 0 ||
    maxPrice < 1000000

  return (
    <div>
      <div
        className={`fixed top-0 left-0 h-full z-[99999999] bg-white text-gray-400 transition-all duration-500 ease-in-out ${
          isOpen ? 'w-[450px]' : 'w-0'
        } overflow-y-auto border-b border-[#C0C4C8]`}
      >
        {/* Style Section */}
        <div className='py-3 px-[12px] border-b border-[#C0C4C8]'>
          <div className='w-[60%] text-start text-[14px] font-barlowMedium tracking-[5px] text-black mb-2'>
            STYLE
          </div>
          <div className='grid grid-cols-4 gap-2'>
            {ringsCategory.map((style, index) => (
              <button
                key={index}
                className='flex flex-col items-center text-xs text-black'
                onClick={() => setSelectedMainStyle(style.param)}
              >
                <div
                  className={`w-[84px] h-[84px] ${
                    selectedMainStyle === style.param ? 'border-2' : 'border'
                  } border-[#A3A3A3] rounded-full mb-1`}
                >
                  <img
                    src={style.image}
                    width={84}
                    height={84}
                    alt='images'
                    className='rounded-full'
                  />
                </div>
                {style.name}
              </button>
            ))}
          </div>
        </div>

        {/* Price Range */}
        <div className='py-3 px-[12px] border-b border-[#C0C4C8]'>
          <label className='block text-sm font-medium text-gray-600 mb-2'>
            Price Range
          </label>
          <div className='flex gap-3 mb-4'>
            <select
              value={priceRangeType}
              onChange={(e) => {
                setPriceRangeType(e.target.value)
                setMinPrice(0)
                setMaxPrice(1000000)
              }}
              className='w-1/2 border border-gray-300 px-3 py-2 rounded-md text-gray-800'
            >
              <option value='under'>Under</option>
              <option value='between'>Between</option>
              <option value='above'>Above</option>
            </select>
          </div>
          {priceRangeType === 'under' && (
            <div>
              <input
                type='range'
                min='0'
                max='1000000'
                step='100'
                value={minPrice}
                onChange={(e) => setMinPrice(Number(e.target.value))}
                className='w-full'
              />
              <div className='text-sm text-gray-600 mt-2'>Under {minPrice}</div>
            </div>
          )}
          {priceRangeType === 'above' && (
            <div>
              <input
                type='range'
                min='0'
                max='1000000'
                step='100'
                value={maxPrice}
                onChange={(e) => setMaxPrice(Number(e.target.value))}
                className='w-full'
              />
              <div className='text-sm text-gray-600 mt-2'>Above {maxPrice}</div>
            </div>
          )}
          {priceRangeType === 'between' && (
            <div>
              <div className='mb-4'>
                <label className='block text-sm text-gray-600'>
                  Min Price: {minPrice}
                </label>
                <input
                  type='range'
                  min='0'
                  max={maxPrice}
                  step='100'
                  value={minPrice}
                  onChange={(e) => setMinPrice(Number(e.target.value))}
                  className='w-full'
                />
              </div>
              <div>
                <label className='block text-sm text-gray-600'>
                  Max Price: {maxPrice}
                </label>
                <input
                  type='range'
                  min={minPrice}
                  max='1000000'
                  step='100'
                  value={maxPrice}
                  onChange={(e) => setMaxPrice(Number(e.target.value))}
                  className='w-full'
                />
              </div>
            </div>
          )}
        </div>

        {/* Diamond shape */}
        <div className='py-3 px-[12px] border-b border-[#C0C4C8]'>
          <div className='w-[60%] text-start text-[14px] font-barlowMedium tracking-[5px] text-black mb-2'>
            DIAMOND SHAPE
          </div>
          <ShopByShapeForFilter
            onShapeClick={(shape) => setSelectedShape(shape)}
            selectedShape={selectedShape}
          />
        </div>

        {/* Metal Style */}
        <div className='py-1 px-[12px] border-b border-[#C0C4C8]'>
          <div className='w-[60%] text-start text-[14px] font-barlowMedium tracking-[5px] text-black mb-2'>
            STYLE
          </div>
          <div className='flex gap-[22px]'>
            {[
              {
                label: 'Yellow Gold',
                icon: '/ic_metal_yellow.svg',
                param: 'color=Yellow Gold',
              },
              {
                label: 'White Gold',
                icon: '/ic_metal_white.svg',
                param: 'color=White Gold',
              },
              {
                label: 'Rose Gold',
                icon: '/ic_metal_rose_gold.svg',
                param: 'color=Rose Gold',
              },
            ].map((item, index) => (
              <li
                key={index}
                className='mb-5 text-black text-[12px] flex flex-col items-center gap-2 cursor-pointer'
                onClick={() => setSelectedStyle(item.param)}
              >
                {item.icon && (
                  <img
                    src={item.icon}
                    alt={item.label}
                    className={`h-[45px] w-[45px] {
                      selectedStyle === item.param ? 'border-2 border-[#A08260] rounded-full' : ''
                    }`}
                  />
                )}
                {item.label}
              </li>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className='flex justify-center my-[15px] gap-[20px]'>
          <button
            onClick={() => (hasFilters ? handleReset() : setIsOpen(false))}
            className='w-[45%] bg-black text-white py-[15px] rounded-lg text-sm font-semibold'
          >
            {hasFilters ? 'Reset' : 'Cancel'}
          </button>

          <button
            onClick={handleSubmit}
            className='w-[45%] bg-black text-white py-[15px] rounded-lg text-sm font-semibold'
          >
            VIEW RESULT
          </button>
        </div>
      </div>

      {/* Trigger Button */}
      <div
        className='h-[46px] px-2.5 py-1 rounded-lg border border-black inline-flex cursor-pointer mt-[31px] mr-[20px]'
        onClick={() => setIsOpen(true)}
      >
        <div className='text-center text-black text-[24px] font-barlowNormal leading-[38px] flex items-center'>
          Filter
          <Image
            src='/product/listing/dropdown-icon.png'
            alt='Dropdown Icon'
            height={9}
            width={9}
            className='ml-2 h-[8px] w-auto'
          />
        </div>
      </div>
    </div>
  )
}
